import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { createTheme, normalizeServiceId } from '@this/constants/themes';
import ErrorBoundary from '@this/shared/error_boundary/error_boundary';
import Arrangement from '@this/components/arrangement/arrangement';
import ArrangerGoogleSignIn from '@this/components/arrangement/arranger_google_sign_in/arranger_google_sign_in';
import useApi from '@this/shared/hooks/use_api';
import { ConfirmModalContainer } from '@this/shared/ui/feedbacks/modal/confirm_modal';
import { AITThemeProvider } from '@this/shared/ui/theme';
import ArrangerUserEdit from '@this/components/arrangement/arranger_user_edit/arranger_user_edit';

export const ArrangementRoot = () => {
  const { data, isLoading } = useApi<{ service_id: number; me: any }>('/arrangement/me');
  const serviceId = normalizeServiceId(data?.service_id);
  const theme = createTheme(serviceId);

  if (isLoading) {
    return null;
  }

  return (
    <ErrorBoundary>
      <HelmetProvider>
        <AITThemeProvider theme={theme}>
          <ConfirmModalContainer>
            <BrowserRouter>
              <Switch>
                <Route
                  exact
                  path="/arrangers/sign_in"
                  render={() => <ArrangerGoogleSignIn serviceId={serviceId} />}
                />
                <Route exact path="/arrangers/password/edit" render={() => <Redirect to="/arrangers/sign_in" />} />
                <Route exact path="/arrangers/edit" component={ArrangerUserEdit} />
                <Route path="/arrangement" render={props => <Arrangement serviceId={serviceId} {...props} />} />
              </Switch>
            </BrowserRouter>
          </ConfirmModalContainer>
        </AITThemeProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
};
